export default __webpack_public_path__ + "static/media/megaman.d3f48286.gif";